interface Type {
  catName: string;
  catId: number;
}

export const typeState = () => ({
  typeList: [],
  typeSelect: [],
});

export const actions = {
  setTypeList({ commit }: any, typeList: Type[]) {
    commit('setTypeList', typeList);
    commit('setTypeSelect', typeList);
  },
};

export const mutations = {
  setTypeList(state: any, typeList: Type[]) {
    state.typeList = typeList;
  },
  setTypeSelect(state: any, typeList: Type[]) {
    state.typeSelect = typeList.map((type) => ({
      text: type.catName,
      value: type.catId,
    }));
  },
};

export default {
  namespaced: true,
  state: typeState,
  actions,
  mutations,
};
